export const parseRegexFromString: (str: string) => RegExp | null = (str: string): RegExp | null => {
  const match: RegExpMatchArray | null = str.match(/^\/(.*)\/([a-z]*)$/i);
  if (!match) {
    return null;
  }
  const [, pattern, flags]: RegExpMatchArray = match;

  return new RegExp(pattern, flags);
};
